/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierBill
 */
export interface CourierBill {
    /**
     * 
     * @type {string}
     * @memberof CourierBill
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CourierBill
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof CourierBill
     */
    dateDue?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CourierBill
     */
    datePaid?: Date;
    /**
     * 
     * @type {string}
     * @memberof CourierBill
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierBill
     */
    paymentMethod?: string;
    /**
     * 
     * @type {Date}
     * @memberof CourierBill
     */
    dateCreated?: Date;
    /**
     * 
     * @type {number}
     * @memberof CourierBill
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CourierBill
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof CourierBill
     */
    planId?: number;
}

/**
 * Check if a given object implements the CourierBill interface.
 */
export function instanceOfCourierBill(value: object): value is CourierBill {
    return true;
}

export function CourierBillFromJSON(json: any): CourierBill {
    return CourierBillFromJSONTyped(json, false);
}

export function CourierBillFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierBill {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'dateDue': json['dateDue'] == null ? undefined : (new Date(json['dateDue'])),
        'datePaid': json['datePaid'] == null ? undefined : (new Date(json['datePaid'])),
        'status': json['status'] == null ? undefined : json['status'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'planId': json['planId'] == null ? undefined : json['planId'],
    };
}

export function CourierBillToJSON(json: any): CourierBill {
    return CourierBillToJSONTyped(json, false);
}

export function CourierBillToJSONTyped(value?: CourierBill | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'amount': value['amount'],
        'dateDue': value['dateDue'] == null ? undefined : ((value['dateDue']).toISOString()),
        'datePaid': value['datePaid'] == null ? undefined : ((value['datePaid']).toISOString()),
        'status': value['status'],
        'paymentMethod': value['paymentMethod'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'id': value['id'],
        'courierId': value['courierId'],
        'planId': value['planId'],
    };
}

